/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Agen_S4Inputs */

const en_mk_tut_agen_s4 = /** @type {(inputs: Mk_Tut_Agen_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click the latest run in the history to open the **transcript**: which tools it used, which data it read, and what it cost in rupiah.`)
};

const id_mk_tut_agen_s4 = /** @type {(inputs: Mk_Tut_Agen_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik run terakhir di bagian riwayat untuk membuka **transkrip**: alat apa yang dipakai, data apa yang dibaca, dan berapa biayanya dalam rupiah.`)
};

/**
* | output |
* | --- |
* | "Click the latest run in the history to open the **transcript**: which tools it used, which data it read, and what it cost in rupiah." |
*
* @param {Mk_Tut_Agen_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_agen_s4 = /** @type {((inputs?: Mk_Tut_Agen_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Agen_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_agen_s4(inputs)
	return en_mk_tut_agen_s4(inputs)
});